import { defineStore } from "ui.vue3.pinia";

export const vplSiteStore = defineStore('siteStore', {
    state: () => ({
        struct: [],
        templateData: [],
        SITE_TEMPLATE_PATH: '',
        menu: {},
        form: {},
        fastview: {},
        rekey: '',
        title: '',
        h1: '',
        type: '',
        edit: false,
        RESPONSE_CODE: '',
        IS_AUTHORIZED: false,
        YA_CLIENT_KEY: '',
        url: '/',
        ancor: '',
        captchaInited: false,
        mapInited: false
    })
});